import * as firebase from 'firebase/app';

import 'firebase/auth';
import 'firebase/analytics';
import 'firebase/firestore';
import 'firebase/storage';
import { APP_STATE_ACTION_TYPE_USER_LOCALE } from '../state/seed-states';

class FirebaseApi {
  constructor(firebaseConfig, state) {
    this.state = state;
    if (!firebase.apps.length && firebaseConfig) {
      const { firebaseOptions, ...restFirebaseConfig } = firebaseConfig;
      this.firebase = firebase.initializeApp(restFirebaseConfig);
    } else {
      // eslint-disable-next-line prefer-destructuring
      this.firebase = firebase.apps[0];
    }
    if (firebaseConfig.firebaseOptions) {
      if (firebaseConfig.firebaseOptions.analytics) {
        this.firebase.analytics();
      }
    }
    if (this.state) {
      this.firebase.auth().languageCode = this.state[APP_STATE_ACTION_TYPE_USER_LOCALE];
    }
  }

  verifyEmail() {
    const p = new Promise((resolve, reject) => {
      if (this.firebase) {
        const { currentUser } = this.firebase.auth();
        if (currentUser) {
          currentUser.sendEmailVerification()
            .then(() => {
              resolve({
                data: {
                  data: {
                    success: true,
                    payload: {
                      message: 'Email sent!',
                    },
                  },
                },
              });
            })
            .catch((error) => {
              reject(new Error(error.message));
            });
        } else {
          reject(new Error('Firebase is not initialized'));
        }
      } else {
        reject(new Error('Firebase is not initialized'));
      }
    });
    return p;
  }

  linkProviderWithPopup(provider) {
    const p = new Promise((resolve, reject) => {
      if (this.firebase) {
        const { currentUser } = this.firebase.auth();
        if (currentUser) {
          currentUser.linkWithPopup(provider).then((result) => {
            // Accounts successfully linked.
            // var credential = result.credential;
            const { user } = result;
            // ...
            resolve({
              data: {
                data: {
                  success: true,
                  payload: {
                    user,
                    message: 'Provider linked!',
                  },
                },
              },
            });
          }).catch((error) => {
            // Handle Errors here.
            // ...
            reject(new Error(error.message));
          });
        } else {
          reject(new Error('Firebase is not initialized'));
        }
      } else {
        reject(new Error('Firebase is not initialized'));
      }
    });
    return p;
  }

  unlinkProviderWithPopup(provider) {
    const p = new Promise((resolve, reject) => {
      if (this.firebase) {
        const { currentUser } = this.firebase.auth();
        if (currentUser) {
          currentUser.unlink(provider).then((user) => {
            resolve({
              data: {
                data: {
                  success: true,
                  payload: {
                    user,
                    message: 'Provider unlinked!',
                  },
                },
              },
            });
          }).catch((error) => {
            // Handle Errors here.
            // ...
            reject(new Error(error.message));
          });
        } else {
          reject(new Error('Firebase is not initialized'));
        }
      } else {
        reject(new Error('Firebase is not initialized'));
      }
    });
    return p;
  }

  loginWithPopup(provider) {
    const p = new Promise((resolve, reject) => {
      if (this.firebase) {
        // provider.addScope('https://www.googleapis.com/auth/contacts.readonly');
        // this.firebase.auth().useDeviceLanguage();
        this.firebase.auth().signInWithPopup(provider).then((result) => {
          // This gives you a Google Access Token. You can use it to access the Google API.
          // var token = result.credential.accessToken;
          // The signed-in user info.
          const { user } = result;
          resolve({
            data: {
              data: {
                success: true,
                payload: {
                  user,
                  message: 'Register success!',
                },
              },
            },
          });
        }).catch((error) => {
          // Handle Errors here.
          // var errorCode = error.code;
          // var errorMessage = error.message;
          // The email of the user's account used.
          // var email = error.email;
          // The firebase.auth.AuthCredential type that was used.
          // var credential = error.credential;
          // ...
          if (error.code === 'auth/account-exists-with-different-credential') {
            const { email } = error;
            this.firebase.auth().fetchSignInMethodsForEmail(email)
              .then((methods) => {
                reject(new Error(`Tolong login menggunakan akun ${methods[0]} Anda.`));
              })
              .catch(() => {
                reject(new Error(error.message));
              });
          } else {
            reject(new Error(error.message));
          }
          // if (error.code === 'auth/account-exists-with-different-credential') {
          //   // User's email already exists.
          //   // The pending Provider credential.
          //   const pendingCred = error.credential;
          //   // The provider account's email address.
          //   const email = error.email;
          //   // Get sign-in methods for this email.
          //   this.firebase.auth().fetchSignInMethodsForEmail(email).then((methods) => {
          //     console.log(methods)
          //     // If the user has several sign-in methods,
          //     // the first method in the list will be the "recommended" method to use.
          //     if (methods[0] === 'password') {
          //       // Asks the user their password.
          //       // In real scenario, you should handle this asynchronously.
          //       // var password = promptUserForPassword(); // TODO: implement promptUserForPassword.
          //       // auth.signInWithEmailAndPassword(email, password).then(function(user) {
          //       //   // Step 4a.
          //       //   return user.linkWithCredential(pendingCred);
          //       // }).then(function() {
          //       //   // Facebook account successfully linked to the existing Firebase user.
          //       //   goToApp();
          //       // });
          //       // return;
          //     }
          //     // All the other cases are external providers.
          //     // Construct provider object for that provider.
          //     // TODO: implement getProviderForProviderId.
          //     const providerOld = this.getProvider(methods[0]);

          //     // At this point, you should let the user know that they already has an account
          //     // but with a different provider, and let them validate the fact they want to
          //     // sign in with this provider.
          //     // Sign in to provider. Note: browsers usually block popup triggered asynchronously,
          //     // so in real scenario you should ask the user to click on a "continue" button
          //     // that will trigger the signInWithPopup.
          //     this.firebase.auth().signInWithPopup(providerOld).then((result) => {
          //       console.log(result)
          //       // Remember that the user may have signed in with an account that has a different email
          //       // address than the first one. This can happen as Firebase doesn't control the provider's
          //       // sign in flow and the user is free to login using whichever account they own.
          //       // Step 4b.
          //       // Link to Facebook credential.
          //       // As we have access to the pending credential, we can directly call the link method.
          //       result.user.linkAndRetrieveDataWithCredential(pendingCred).then((usercred) => {
          //         console.log(usercred)
          //         // Facebook account successfully linked to the existing Firebase user.
          //         resolve({
          //           data: {
          //             data: {
          //               success: true,
          //               payload: {
          //                 user: '',
          //                 message: 'Register success!',
          //               },
          //             },
          //           },
          //         });
          //       });
          //     });
          //   });
          // }
        });
      } else {
        reject(new Error('Firebase is not initialized'));
      }
    });
    return p;
  }

  signInProviderWithPopup(provider) {
    const p = new Promise((resolve, reject) => {
      if (this.firebase) {
        this.firebase.auth().signInWithPopup(provider).then((result) => {
          const { user } = result;
          resolve({
            data: {
              data: {
                success: true,
                payload: {
                  user,
                  message: 'Sign in success!',
                },
              },
            },
          });
        }).catch((error) => {
          reject(new Error(error.message));
        });
      } else {
        reject(new Error('Firebase is not initialized'));
      }
    });
    return p;
  }

  signInPhoneNumber(phoneNumber, appVerifier) {
    const p = new Promise((resolve, reject) => {
      if (this.firebase) {
        this.firebase.auth().signInWithPhoneNumber(phoneNumber, appVerifier).then((confirmationResult) => {
          resolve({
            data: {
              data: {
                success: true,
                payload: {
                  confirmationResult,
                  message: 'SMS sent!',
                },
              },
            },
          });
        }).catch((error) => {
          reject(new Error(error.message));
        });
      } else {
        reject(new Error('Firebase is not initialized'));
      }
    });
    return p;
  }

  confirmSMSCode(confirmationResult, code) {
    const p = new Promise((resolve, reject) => {
      if (this.firebase) {
        confirmationResult.confirm(code).then(() => {
          resolve({
            data: {
              data: {
                success: true,
                payload: {
                  message: 'Sign in success!',
                },
              },
            },
          });
        }).catch((error) => {
          reject(new Error(error.message));
        });
      } else {
        reject(new Error('Firebase is not initialized'));
      }
    });
    return p;
  }

  updatePassword(oldPassword, newPassword) {
    const p = new Promise((resolve, reject) => {
      if (this.firebase) {
        const { currentUser } = this.firebase.auth();
        if (currentUser) {
          const { email } = currentUser;
          const credential = firebase.auth.EmailAuthProvider.credential(email, oldPassword);

          currentUser.reauthenticateWithCredential(credential).then(() => {
            currentUser.updatePassword(newPassword).then(() => {
              resolve({
                data: {
                  data: {
                    success: true,
                    payload: {
                      message: 'Password updated!',
                    },
                  },
                },
              });
            }).catch((error) => {
              // Handle Errors here.
              // ...
              reject(new Error(error.message));
            });
          }).catch((error) => {
            // Handle Errors here.
            // ...
            reject(new Error(error.message));
          });
        } else {
          reject(new Error('Firebase is not initialized'));
        }
      } else {
        reject(new Error('Firebase is not initialized'));
      }
    });
    return p;
  }

  updateEmail(password, newEmail) {
    const p = new Promise((resolve, reject) => {
      if (this.firebase) {
        const { currentUser } = this.firebase.auth();
        if (currentUser) {
          const { email } = currentUser;
          const credential = firebase.auth.EmailAuthProvider.credential(email, password);

          currentUser.reauthenticateWithCredential(credential).then(() => {
            currentUser.updateEmail(newEmail).then(() => {
              resolve({
                data: {
                  data: {
                    success: true,
                    payload: {
                      message: 'Email updated!',
                    },
                  },
                },
              });
            }).catch((error) => {
              // Handle Errors here.
              // ...
              reject(new Error(error.message));
            });
          }).catch((error) => {
            // Handle Errors here.
            // ...
            reject(new Error(error.message));
          });
        } else {
          reject(new Error('Firebase is not initialized'));
        }
      } else {
        reject(new Error('Firebase is not initialized'));
      }
    });
    return p;
  }

  updatePasswordPopup(newPassword) {
    const p = new Promise((resolve, reject) => {
      if (this.firebase) {
        const { currentUser } = this.firebase.auth();
        if (currentUser) {
          const { email } = currentUser;

          this.firebase.auth().fetchSignInMethodsForEmail(email).then((methods) => {
            if (methods.length > 0) {
              const provider = this.getProvider(methods[0]); // not password
              currentUser.reauthenticateWithPopup(provider).then(() => {
                currentUser.updatePassword(newPassword).then(() => {
                  resolve({
                    data: {
                      data: {
                        success: true,
                        payload: {
                          message: 'Password updated!',
                        },
                      },
                    },
                  });
                }).catch((error) => {
                  // Handle Errors here.
                  // ...
                  reject(new Error(error.message));
                });
              }).catch((error) => {
                // Handle Errors here.
                // ...
                reject(new Error(error.message));
              });
            } else {
              reject(new Error('Please link at least one provider (e.g. Google) to set up a new password.'));
            }
          }).catch((error) => {
            // Handle Errors here.
            // ...
            reject(new Error(error.message));
          });
        } else {
          reject(new Error('Firebase is not initialized'));
        }
      } else {
        reject(new Error('Firebase is not initialized'));
      }
    });
    return p;
  }

  updateEmailWithProvider(newEmail) {
    const p = new Promise((resolve, reject) => {
      if (this.firebase) {
        const { currentUser } = this.firebase.auth();
        if (currentUser) {
          const { email } = currentUser;

          this.firebase.auth().fetchSignInMethodsForEmail(email).then((methods) => {
            if (methods.length > 0) {
              const provider = this.getProvider(methods[0]); // not password
              currentUser.reauthenticateWithPopup(provider).then(() => {
                currentUser.updateEmail(newEmail).then(() => {
                  resolve({
                    data: {
                      data: {
                        success: true,
                        payload: {
                          message: 'Email updated!',
                        },
                      },
                    },
                  });
                }).catch((error) => {
                  // Handle Errors here.
                  // ...
                  reject(new Error(error.message));
                });
              }).catch((error) => {
                // Handle Errors here.
                // ...
                reject(new Error(error.message));
              });
            } else {
              reject(new Error('Please link at least one provider (e.g. Google) to set up a new password.'));
            }
          }).catch((error) => {
            // Handle Errors here.
            // ...
            reject(new Error(error.message));
          });
        } else {
          reject(new Error('Firebase is not initialized'));
        }
      } else {
        reject(new Error('Firebase is not initialized'));
      }
    });
    return p;
  }

  sendPasswordResetEmail(email) {
    const p = new Promise((resolve, reject) => {
      if (this.firebase) {
        this.firebase.auth().sendPasswordResetEmail(email).then(() => {
          resolve({
            data: {
              data: {
                success: true,
                payload: {
                  message: 'Password reset email sent!',
                },
              },
            },
          });
        }).catch((error) => {
          // Handle Errors here.
          // ...
          reject(new Error(error.message));
        });
      } else {
        reject(new Error('Firebase is not initialized'));
      }
    });
    return p;
  }

  deleteUser(data) {
    const p = new Promise((resolve, reject) => {
      if (this.firebase) {
        const { currentUser } = this.firebase.auth();
        if (currentUser) {
          const { email } = currentUser;
          const credential = firebase.auth.EmailAuthProvider.credential(email, data.password);

          currentUser.reauthenticateWithCredential(credential).then(() => {
            currentUser.delete().then(() => {
              resolve({
                data: {
                  data: {
                    success: true,
                    payload: {
                      message: 'User deleted!',
                    },
                  },
                },
              });
            }).catch((error) => {
              // Handle Errors here.
              // ...
              reject(new Error(error.message));
            });
          }).catch((error) => {
            // Handle Errors here.
            // ...
            reject(new Error(error.message));
          });
        } else {
          reject(new Error('Firebase is not initialized'));
        }
      } else {
        reject(new Error('Firebase is not initialized'));
      }
    });
    return p;
  }

  // eslint-disable-next-line class-methods-use-this
  getProvider(method) {
    switch (method) {
      case 'google.com':
        return new firebase.auth.GoogleAuthProvider();
      case 'facebook.com':
        return new firebase.auth.FacebookAuthProvider();
      case 'github.com':
        return new firebase.auth.GithubAuthProvider();
      case 'twitter.com':
        return new firebase.auth.TwitterAuthProvider();
      default:
        return null;
    }
  }

  linkProvider(providerId) {
    const provider = this.getProvider(providerId);
    return this.linkProviderWithPopup(provider);
  }

  unlinkProvider(providerId) {
    const provider = providerId;
    return this.unlinkProviderWithPopup(provider);
  }

  signInProvider(providerId) {
    const provider = this.getProvider(providerId);
    return this.signInProviderWithPopup(provider);
  }

  loginGoogle() {
    const provider = this.getProvider('google.com');
    return this.loginWithPopup(provider);
  }

  loginFacebook() {
    const provider = this.getProvider('facebook.com');
    return this.loginWithPopup(provider);
  }

  registerEmailPassword(email, password) {
    const p = new Promise((resolve, reject) => {
      if (this.firebase) {
        this.firebase.auth().createUserWithEmailAndPassword(email, password)
          .then((data) => {
            resolve({
              data: {
                data: {
                  success: true,
                  payload: {
                    user: data.user,
                    message: 'Register success!',
                  },
                },
              },
            });
          })
          .catch((error) => {
            reject(new Error(error.message));
          });
      } else {
        reject(new Error('Firebase is not initialized'));
      }
    });
    return p;
  }

  registerEmailLink(email) {
    const actionCodeSettings = {
      // URL you want to redirect back to. The domain (www.example.com) for this
      // URL must be whitelisted in the Firebase Console.
      url: 'http://localhost:3000/login-link', // TODO change with real base page
      // This must be true.
      handleCodeInApp: true,
      // iOS: {
      //   bundleId: 'com.example.ios'
      // },
      // android: {
      //   packageName: 'com.example.android',
      //   installApp: true,
      //   minimumVersion: '12'
      // },
      // dynamicLinkDomain: 'example.page.link'
    };
    const p = new Promise((resolve, reject) => {
      if (this.firebase) {
        this.firebase.auth().sendSignInLinkToEmail(email, actionCodeSettings)
          .then(() => {
            resolve({
              data: {
                data: {
                  success: true,
                  payload: {
                    email,
                    message: 'Email sent!',
                  },
                },
              },
            });
          })
          .catch((error) => {
            reject(new Error(error.message));
          });
      } else {
        reject(new Error('Firebase is not initialized'));
      }
    });
    return p;
  }

  loginEmailLink(email, link) {
    const p = new Promise((resolve, reject) => {
      if (this.firebase) {
        this.firebase.auth().signInWithEmailLink(email, link)
          .then((result) => {
            const { user } = result;
            resolve({
              data: {
                data: {
                  success: true,
                  payload: {
                    user,
                    message: 'Login success!',
                  },
                },
              },
            });
          })
          .catch((error) => {
            reject(new Error(error.message));
          });
      } else {
        reject(new Error('Firebase is not initialized'));
      }
    });
    return p;
  }

  loginEmailPassword(email, password, rememberMe) {
    const p = new Promise((resolve, reject) => {
      if (this.firebase) {
        const persistence = rememberMe ? firebase.auth.Auth.Persistence.LOCAL
          : firebase.auth.Auth.Persistence.SESSION;
        this.firebase.auth().setPersistence(persistence)
          .then(() => {
            this.firebase.auth().signInWithEmailAndPassword(email, password)
              .then((data) => {
                resolve({
                  data: {
                    data: {
                      success: true,
                      payload: {
                        user: data.user,
                        message: 'Login success!',
                      },
                    },
                  },
                });
              })
              .catch((error) => {
                reject(new Error(error.message));
              });
          })
          .catch((error) => {
            reject(new Error(error.message));
          });
      } else {
        reject(new Error('Firebase is not initialized'));
      }
    });
    return p;
  }

  logout() {
    const p = new Promise((resolve, reject) => {
      if (this.firebase) {
        this.firebase.auth().signOut()
          .then((data) => {
            resolve({
              success: true,
              data: {
                user: data,
                message: 'Logout success!',
              },
            });
          })
          .catch((error) => {
            reject(new Error(error.message));
          });
      } else {
        reject(new Error('Firebase is not initialized'));
      }
    });
    return p;
  }

  updateProfile(data) {
    const p = new Promise((resolve, reject) => {
      if (this.firebase) {
        const { currentUser } = this.firebase.auth();
        if (currentUser) {
          currentUser.updateProfile(data)
            .then(() => {
              resolve({
                data: {
                  data: {
                    success: true,
                    message: 'Profile updated!',
                  },
                },
              });
            })
            .catch((error) => {
              // Error updating user's photoURL.
              reject(new Error(error.message));
            });
        } else {
          reject(new Error('Firebase is not initialized'));
        }
      } else {
        reject(new Error('Firebase is not initialized'));
      }
    });
    return p;
  }

  updateProfilePhoto(file) {
    const p = new Promise((resolve, reject) => {
      if (this.firebase) {
        const user = this.firebase.auth().currentUser;
        let fileExt = file.name.split('.');
        fileExt = fileExt[fileExt.length - 1];
        const imageRef = this.firebase.storage().ref().child(`avatars/${user.uid}/${user.uid}.${fileExt}`);
        imageRef.put(file)
          .then((snapshot) => {
            console.log(snapshot);
            imageRef.getDownloadURL()
              .then((url) => {
                user.updateProfile({
                  photoURL: url,
                  // photoURL: null,
                })
                  .then(() => {
                    resolve({
                      data: {
                        data: {
                          success: true,
                          message: 'Profile photo updated!',
                        },
                      },
                    });
                  })
                  .catch((error) => {
                    // Error updating user's photoURL.
                    reject(new Error(error.message));
                  });
              })
              .catch((error) => {
                // Error getting image's download URL.
                reject(new Error(error.message));
              });
          })
          .catch((error) => {
            // Error uploading image.
            reject(new Error(error.message));
          });
      } else {
        reject(new Error('Firebase is not initialized'));
      }
    });
    return p;
  }

  removeProfilePhoto() {
    const p = new Promise((resolve, reject) => {
      if (this.firebase) {
        const { currentUser } = this.firebase.auth();
        if (currentUser) {
          // const imageRef = this.firebase.storage().refFromURL(user.photoURL);
          // console.log(imageRef)
          // imageRef.delete()
          //   .then((snapshot) => {
          //     console.log(snapshot);
          currentUser.updateProfile({
            photoURL: null,
          })
            .then(() => {
              resolve({
                data: {
                  data: {
                    success: true,
                    message: 'Profile photo removed!',
                  },
                },
              });
            })
            .catch((error) => {
              // Error updating user's photoURL.
              reject(new Error(error.message));
            });
          // })
          // .catch((error) => {
          //   // Error uploading image.
          //   reject(new Error(error.message));
          // });
        } else {
          reject(new Error('Firebase is not initialized'));
        }
      } else {
        reject(new Error('Firebase is not initialized'));
      }
    });
    return p;
  }
}

export default FirebaseApi;
